import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { Navigate, Outlet, useLocation, useRoutes } from 'react-router-dom';
// creates a beautiful scrollbar
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Footer from 'components/Footer/Footer.js';
// import Sidebar from "components/Sidebar/Sidebar.js";
import Sidebar from 'components/Tvendo/Common/MainSideBar';
import FixedPlugin from 'components/FixedPlugin/FixedPlugin.js';
// import useAuthValidator from 'hooks/useAuthValidator';
// import routes from "routes.js";
// import routes from "tvendo-routes";

import Button from 'components/CustomButtons/Button.js';
import { useNavigate } from 'react-router-dom';

import styles from 'assets/jss/material-dashboard-pro-react/layouts/adminStyle.js';
import { ArrowBackIos } from '@material-ui/icons';
import { useLayoutRoutes } from 'contexts/routeReducer';
import { RouteAction } from 'contexts/routeReducer';
import { useCurrentRouteName } from 'contexts/routeReducer';
import { useMounted } from 'hooks/useMounted';
import { useAuth } from 'hooks/useAuth';
import { useApp } from 'hooks/useApp';
import Loading from './Loading';

var ps;

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const { ...rest } = props;
  const mounted = useMounted();
  const location = useLocation();
  const layoutPath = 'admin';
  const { routeState, routeDispacher, logoText } = useApp();
  const { isInitialized, isAuthenticated } = useAuth();

  const routes = routeState.routes;
  // const layoutRoutes = useLayoutRoutes(routes, layoutPath);
  // const router = useRoutes(layoutRoutes);

  useEffect(() => {
    routeDispacher({ type: RouteAction.current, payload: location.pathname });
  }, [location]);
  // const auth = useAuthValidator();
  const auth = false;
  const history = useNavigate();

  // states and functions
  const [mobileOpen, setMobileOpen] = useState(false);
  const [miniActive, setMiniActive] = useState(false);
  const [image, setImage] = useState(require('assets/img/sidebar-2.jpg'));
  const [color, setColor] = useState('blue');
  const [bgColor, setBgColor] = useState('black');
  // const [hasImage, setHasImage] = React.useState(true);
  const [fixedClasses, setFixedClasses] = useState('dropdown');
  const [logo, setLogo] = useState(require('assets/img/tvendo-icon-web.png'));
  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    ' ' +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  useEffect(() => {
    if (auth) {
      if (navigator.platform.indexOf('Win') > -1) {
        ps = new PerfectScrollbar(mainPanel.current, {
          suppressScrollX: true,
          suppressScrollY: false
        });
        document.body.style.overflow = 'hidden';
      }
      window.addEventListener('resize', resizeFunction);

      // Specify how to clean up after this effect:
      return function cleanup() {
        if (navigator.platform.indexOf('Win') > -1) {
          ps.destroy();
        }
        window.removeEventListener('resize', resizeFunction);
      };
    }
  });

  // functions for changeing the states from components
  const handleImageClick = (image) => {
    setImage(image);
  };
  const handleColorClick = (color) => {
    setColor(color);
    //props.themeContext.color = color;
  };
  const handleBgColorClick = (bgColor) => {
    switch (bgColor) {
      case 'white':
        setLogo(require('assets/img/logo.svg'));
        break;
      default:
        setLogo(require('assets/img/logo-white.svg'));
        break;
    }
    setBgColor(bgColor);
  };
  const handleFixedClick = () => {
    if (fixedClasses === 'dropdown') {
      setFixedClasses('dropdown show');
    } else {
      setFixedClasses('dropdown');
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };

  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  const brandText = useCurrentRouteName(routeState.paths, location.pathname);

  if (!isInitialized()) {
    return <Loading />;
  }

  if (isInitialized() && !isAuthenticated()) {
    return <Loading />;
  }

  return (
    <>
      <div className={classes.wrapper}>
        <Sidebar
          routes={routes}
          logoText={logoText}
          logo={logo}
          image={image}
          handleDrawerToggle={handleDrawerToggle}
          open={mobileOpen}
          color={color}
          bgColor={bgColor}
          miniActive={miniActive}
          {...rest}
        />
        <div className={mainPanelClasses} ref={mainPanel}>
          <AdminNavbar
            sidebarMinimize={sidebarMinimize}
            miniActive={miniActive}
            brandText={brandText}
            handleDrawerToggle={handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}

          <div id="mainContent" className={classes.content} style={{ marginTop: '50px' }}>
            {/* <Button size="sm" onClick={history.goback} style={{ marginLeft: '15px' }}>
              <ArrowBackIos className={classes.icons} /> Atrás
            </Button> */}
            <div className={classes.container}>
              <Outlet />
            </div>
          </div>
          <Footer fluid />
          <FixedPlugin
            handleImageClick={handleImageClick}
            handleColorClick={handleColorClick}
            handleBgColorClick={handleBgColorClick}
            color={color}
            bgColor={bgColor}
            bgImage={image}
            handleFixedClick={handleFixedClick}
            fixedClasses={fixedClasses}
            sidebarMinimize={sidebarMinimize.bind(this)}
            miniActive={miniActive}
          />
        </div>
      </div>
    </>
  );
}
